import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";

export default function WhyMatters() {
    const { t } = useLang();
    return (
        <section id="why" className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)]" data-testid="sau-why">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="text-center max-w-3xl mx-auto">
                    <SectionHeading align="center" eyebrow={t.whyMatters.eyebrow} title={t.whyMatters.title} />
                    <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed">
                        {t.whyMatters.body}
                    </p>
                </div>

                <div className="mt-10 sm:mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
                    {t.whyMatters.pointers.map((p, i) => (
                        <div key={`why-${i}`} className="sau-reveal sau-gradient-border p-[1px] rounded-2xl">
                            <div className="rounded-2xl bg-[#0B1A2B] p-7 h-full">
                                <div className="flex items-baseline gap-3">
                                    <span className="text-3xl font-light text-[color:var(--sau-accent)]">{p.k}</span>
                                    <span className="text-xs uppercase tracking-[0.22em] text-[color:var(--sau-muted)]">
                                        {p.t}
                                    </span>
                                </div>
                                <p className="mt-5 text-sm leading-relaxed text-[color:var(--sau-text-2)]">{p.d}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
